import styled from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section`
    padding: 0.5rem 0;
    width: 100%;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1rem 0;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        flex-direction: row;
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`
export const RegionListContainer = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-wrap: ${({ theme }) => theme.style.flexWrap.wrap};
    margin-top: 1rem;
    padding: 0 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0;
    }
`

export const ShowMoreText = styled.div`
    font-size: ${({ theme }) => theme.typography.font.size.small};
    margin: 0.75rem auto 0;
    font-family: ${({ theme }) => theme.typography.font.family.latoVerdana};
    font-weight: 700;
    cursor: pointer;
    line-height: 1.5rem;
    color: ${props => props.theme.colors.tfwBlue12};
    padding: 0 1rem;
`
